import { useWrapRequest } from 'use-wrap-request';
import { Api } from '../../core/api';
import { injectTSDI } from '../../core/tsdi';
import { VendorCreateRequestDto } from '@api/WalletClient';

export function useVendorCreateStore() {
    const { walletClient } = injectTSDI(Api);

    const createVendor = useWrapRequest(
        async (data: VendorCreateRequestDto) => {
            const result =
                await walletClient.supportApi.vendorSupportControllerCreateVendor(
                    data
                );
            return result.data;
        },
        {
            defaultData: null
        }
    );

    return {
        createVendor
    };
}
